import { Routes } from '@angular/router';
import { rolesGuard } from '../../partials/guards/roles.guard';
import { CASE_PORTFOLIO_ROLES, CASE_READ_ROLES } from './data/dictionaries';
import { caseIdGuard } from './guards/case-id.guard';
import { MOCK_NOTICE, mockDataGuard } from './guards/mock-data.guard';

// AMLOfficer case-management module. Mirrors the prototype's internal nav
// (Cases | Dashboard | Signals | VASP | Events) as child routes under one shell.
// Porting status from the prototype — see ./PORTING-CHECKLIST.md
export const caseManagementRoutes: Routes = [
    {
        path: 'case-management',
        canActivate: [rolesGuard([...CASE_READ_ROLES])],
        loadComponent: () => import('./case-management.component').then(c => c.CaseManagementComponent),
        children: [
            { path: '', pathMatch: 'full', redirectTo: 'cases' },
            {
                path: 'cases',
                loadComponent: () => import('./pages/cases/cases.component').then(c => c.CasesComponent),
            },
            {
                path: 'case/:id',
                canActivate: [caseIdGuard],
                loadComponent: () => import('./pages/case-detail/case-detail.component').then(c => c.CaseDetailComponent),
            },
            {
                path: 'dashboard',
                canActivate: [rolesGuard([...CASE_PORTFOLIO_ROLES])],
                loadComponent: () => import('./pages/dashboard/dashboard.component').then(c => c.CaseDashboardComponent),
            },
            {
                path: 'signals',
                canActivate: [rolesGuard([...CASE_PORTFOLIO_ROLES])],
                loadComponent: () => import('./pages/signals/signals.component').then(c => c.SignalsComponent),
            },
            // The VASP directory is not in the 6.3 API yet — the screen warns before it opens, so its
            // numbers are not mistaken for production data. See ./guards/mock-data.guard.ts
            // {
            //     path: 'vasp',
            //     canActivate: [mockDataGuard(MOCK_NOTICE.vasp)],
            //     loadComponent: () => import('./pages/vasp/vasp.component').then(c => c.VaspComponent),
            // },
            {
                path: 'events',
                canActivate: [rolesGuard([...CASE_PORTFOLIO_ROLES])],
                loadComponent: () => import('./pages/events/events.component').then(c => c.EventsComponent),
            },
            {
                path: 'wallet-by-signal',
                canActivate: [rolesGuard([...CASE_PORTFOLIO_ROLES])],
                loadComponent: () => import('../wallets-by-clusters/wallets-by-clusters.component').then(c => c.WalletsByClustersComponent),
            },
        ],
    },
];
